var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalyticsBlock',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"default-value":_vm.defaultValue},on:{"update":_vm.fetchPageViews}})}
var staticRenderFns = []

export { render, staticRenderFns }